import moment from "moment";
// import PinIcon from "../../Images/pin.svg";
// import ArchiveIcon from "../../Images/archive.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faArrowUpRightFromSquare, faReply } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import { AxiosError } from "axios";
import { MessageThreadModel } from "../../models/MessageCenterModels";
import Service from "../../services";
import { catchError } from "../../utils/Utils";
import { ReactComponent as PinIcon } from "../../images/MessageCenter/pin.svg";
import { ReactComponent as ArchiveIcon } from "../../images/MessageCenter/archive.svg";
import { getMessageThreadUserName } from "../../utils/GeneralUtils";
import { useNavigate } from "react-router";
import { RoutesEnum } from "../../utils/RoutesUtil";

interface MessageThreadCardProps {
  messageThread: MessageThreadModel;
  isActive: boolean;
  handleTreadClick: (thread: MessageThreadModel) => void;
  config: any;
  quickMessageReply?: (thread: MessageThreadModel) => void;
}

const MessageThreadCard = (props: MessageThreadCardProps) => {
  const { messageThread, isActive, handleTreadClick, config, quickMessageReply } = props;
  const navigate = useNavigate();

  // set moment calender to display day in perticular formats
  moment.locale("en", {
    calendar: {
      lastDay: "[Yesterday]",
      sameDay: "LT",
      lastWeek: "dddd",
      sameElse: "L LT",
    },
  });

  return (
    <div
      className={`
        messageThreadCard 
        ${config?.activeThread && isActive ? "active" : ""}
        ${config?.archive && messageThread?.archiveFlag ? "archive" : ""} 
        ${config?.pin && messageThread?.pinnedFlag ? "pin" : ""}
        ${config?.hoverOptions ? "enable-hover-options" : ""}
      `}
      onClick={() => handleTreadClick(messageThread)}
    >
      {messageThread?.readFlag ? <></> : (
        <div className="read">
          <div className="oval"></div>
        </div>
      )}
      <div className="person">
        <div className="person-image">
          {`${
            messageThread?.userDisplayFirstName ?
            messageThread?.userDisplayFirstName?.[0]?.toUpperCase() : ''
          }${
            messageThread?.userDisplayLastName ?
            messageThread?.userDisplayLastName?.[0]?.toUpperCase() : ''
          }`}
        </div>
      </div>
      <div className={`details ${config?.latestRight ? 'latest-right' : ''}`}>
        <div className="name-subject">
          <div className="name">
            {getMessageThreadUserName(messageThread)}
          </div>
          <div className="subject mb-1">{messageThread?.subject}</div>
        </div>
        {/* need to display right in some cases */}
        <div className="latest mb-3">
          {messageThread?.latestMessage || "-"}
        </div>
      </div>
      <div className="other-options">

        <div className="date">
          {moment(messageThread?.latestMessageTime).calendar()}{" "}
          <FontAwesomeIcon icon={faAngleRight} />
        </div>

        <div className="hover-options">
          <div className='quick-links'>
            <div className='quick-reply' onClick={() => quickMessageReply && quickMessageReply(messageThread)}>
              <FontAwesomeIcon icon={faReply} size={"2xs"} className='faReply' />
              <p className="quick-text">Quick Reply</p>
            </div>
            <div className='open-mc' onClick={() => messageThread && navigate(`/${RoutesEnum.MESSAGE_CENTER}/${messageThread?.id}`)}>
              <FontAwesomeIcon icon={faArrowUpRightFromSquare} size={"2xs"} className='faReply' />
              <p className="quick-text">Open in MC</p>
            </div>
          </div>
        </div>
        
        <div className="bottomIcons">
          {config?.pin && messageThread?.pinnedFlag ? (
            <div className="pin">
              <PinIcon className="svg-image pin-image" />
            </div>
          ) : <></>}
          {config?.archive && messageThread?.archiveFlag ? (
            <div className="archiveIcon">
              <ArchiveIcon className="svg-image archive-image" />
            </div>
          ) : <></>}
        </div>
      </div>
    </div>
  );
};

export default MessageThreadCard;
